import { Button } from "@/components/core/buttons/Button";
import { cn } from "@/lib/utils";
import { HTMLMotionProps, motion } from "framer-motion";
import { useAuth } from "hooks/useAuth";
import Image from "next/image";
import { useRouter } from "next/router";
import { useRef } from "react";
import { useOnClickOutside } from "usehooks-ts";

import { ExtensionLink } from "../ExtensionLink";
import { IconBox } from "../IconBox";
import { Text } from "../Text";
import { SideFooter } from "./Footer";
import { NavMenu } from "./NavMenu";

export const Drawer = ({
    onClose,
    className,
    ...props
}: HTMLMotionProps<"aside"> & {
    onClose: () => void;
    className?: string;
}) => {
    const router = useRouter();
    const drawerRef = useRef<HTMLElement>(null);

    const { loading, me } = useAuth();

    useOnClickOutside(drawerRef as any, onClose);

    const MotionAside = motion.aside as any;

    return (
        <MotionAside
            ref={drawerRef}
            className={cn(
                "flex h-full w-[300px] max-w-full flex-col bg-background dark:bg-common-black-main",
                className
            )}
            {...props}
        >
            <div className="flex h-[194px] flex-col bg-grey-a100">
                <IconBox
                    className="ml-3 mt-3 cursor-pointer"
                    name="Close"
                    size="xl"
                    color="secondary"
                    onClick={onClose}
                />
                <div className="flex h-full flex-col items-center justify-center gap-3.5 border-b border-text-focus-visible">
                    {loading ? null : me ? (
                        <ExtensionLink href="/mypage">
                            <div className="flex cursor-pointer flex-col items-center">
                                <Image
                                    alt="profile"
                                    src={me.profileImg}
                                    width={36}
                                    height={36}
                                    className="mb-3.5 rounded-xl"
                                />
                                <Text variant="subtitle2">{me.email}</Text>
                                <Button
                                    size="medium"
                                    variant="text"
                                    color="grey"
                                    endIcon="ChevronRight"
                                >
                                    나의 정보 보기
                                </Button>
                            </div>
                        </ExtensionLink>
                    ) : (
                        <div className="flex flex-col items-center">
                            <ExtensionLink href="#signin">
                                <Button
                                    className="mb-3"
                                    color="secondary"
                                    size="large"
                                    disabled={
                                        process.env
                                            .NEXT_PUBLIC_MAINTENANCE_MODE ===
                                        "true"
                                    }
                                >
                                    믹스 로그인하기
                                </Button>
                            </ExtensionLink>
                            <Text
                                className="whitespace-pre-wrap text-center text-text-secondary"
                                variant="body3"
                                tag="div"
                            >
                                {`로그인을 하시면 더 많은 정보와\n기능을 이용할 수 있습니다`}
                            </Text>
                        </div>
                    )}
                </div>
            </div>
            <div className="flex flex-1 flex-col justify-between p-5">
                <NavMenu showSubMenu={false} />
                <SideFooter />
            </div>
        </MotionAside>
    );
};
